export default "__VITE_ASSET__DsTTuG$A__"